import React, { Component } from 'react';
import Login from '~/views/Popup/views/Login';
import './index.css';
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

class LoginHardwall extends Component {
  render() {
    if(this.state.user){
      window.location="/home"
    }
    const { desktopImageURL} = this.props.data.metadataMap
    return (
      <div className='login-hardwall' style={{ backgroundImage: `url(${desktopImageURL})`}}>
        <div className='popup-view'>
            <Login/>
        </div>
      </div>
    )
  }
}

connect(
  LoginHardwall,
  state => ({ user: state.user }),
  userStore
);

export default LoginHardwall;